import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { query, where, collection, onSnapshot, doc, getDocs, orderBy } from "firebase/firestore";
import logo_default from "../../assets/logo_default.jpg";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from '../../components_root/ToastContext.jsx';
import Lodinging from "../../components_root/loading.jsx";
import Lodingingimg from "../../components_root/loadingimg.jsx";
import { MdArrowBackIos, MdClose, MdAddAPhoto, MdUploadFile, MdDelete, MdUpload, MdDownload, MdOutlineInventory } from "react-icons/md";
import { PiBooks } from "react-icons/pi";
import { Uploader_files } from "../../components_root/uploader_files.js";
import { Update_voucher } from "./Update_voucher.js";
import './voucher.css';
import { IoSwapVertical } from "react-icons/io5";
import { Voucher_File_manager } from "./voucher_file_manager.js";
import { Ledger_accounts_manager } from "../ledger_accounts_root/ledger_accounts_manager.js";
import Ledger_accounts_reports_profile from "../../company_root/staff_account_root/ledger_accounts_reports_profile.jsx";
import Ledger_accounts_profile from "../../company_root/staff_account_root/ledger_accounts_profile.jsx";
import { Randomcode } from "../../components_root/rendom_code.js";
import { Save_log_history } from "../../log_history_root/save_log_history.js";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Voucher_edit() {
    const servicetablename = "accountingfinancedb";
    const [voucher, setVoucher] = useState("");
    const [amount, setAmount] = useState();
    const [description, setdescription] = useState("");
    const { Toastshow } = Toast();
    const [isLoading_banner, setIsLoading_banner] = useState(false);
    const navigate = useNavigate();
    const [voucherid, setVoucherid] = useState("");
    const [IsLoading2, setIsLoading2] = useState(false);
    const [editable, setEditable] = useState(false);
    const [ledgereditable, setLedgereditable] = useState(false);
    const [isedit, setIsedit] = useState(false);
    const [vouchersdata, setVouchersdata] = useState([]);

    const [statusdata, setStatusdata] = useState(false);
    const [logoUrl, setLogoUrl] = useState("");
    const [old_file_uid, setOld_file_uid] = useState("");
    const [manageamount, setManageamount] = useState(0);
    const [manageacalc, setManagecalc] = useState("+");
    const [mathedcalc, setmathedcalc] = useState("%");
    const [managenameoption, setManagenameoption] = useState("");
    const [filename, setFilename] = useState("");
    const [fileshortname, setFileshortname] = useState("");
    const [filenumber, setFilenumber] = useState(false);
    const [issue_date, setIssue_date] = useState(false);
    const [expiry_date, setExpiry_date] = useState(false);

    //
    const [voucher_file_manager_data, setVoucher_file_manager_data] = useState([]);
    const [filedescription, setFiledescription] = useState("");
    const [managename, setManagename] = useState("");
    const [manageaccountguid, setManageaccountguid] = useState("0");
    const [manage_ledger_accountsdata, setManage_ledger_accountsdata] = useState([]);
    const [ledger_accountsdata, setLedger_accountsdata] = useState([]);
    const [voucher_type, setVoucher_type] = useState("receipt");
    const [paypublic, setPaypublic] = useState(false);
    const [logid, setlogid] = useState(Randomcode(15));
    //
    const [stockname, setstockname] = useState("");
    const [itemname, setitemname] = useState("");
    const [itemprice, setitemprice] = useState();
    const [stockdescription, setstockdescription] = useState("");
    const [perday, setPerday] = useState(false);
    const [voucher_file_stock_qty_data, setVoucher_file_stock_qty_data] = useState([]);
    //
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const uid = params.get("uid");

        if (uid) {
            setVoucherid(uid);
            setIsedit(true);
        } else {
            setIsedit(false);
        }
    }, [window.location.search]);


    const handleCreate = async () => {
        if (!voucher || !voucher.trim()) {
            Toastshow("Please enter Voucher name.");
            return;
        }
        if (!description || !description.trim()) {
            Toastshow("Please enter description.");
            return;
        }
        setlogid(Randomcode(15));
        const dataupdates = {
            log_id: logid,
            voucher_type: voucher_type,
            voucher: voucher,
            editable,
            paypublic,
            status: statusdata,
            amount: isNaN(Number(amount)) ? 0 : Number(amount),
            description,
            // Add other necessary fields here
        };
        create_log(dataupdates, voucherid, "charges", voucher, voucher, "voucher update", statusdata);
    };
    const create_log = async (dataupdates, filedid, account_type, accounts_name, description, verify_note, account_status) => {

        const log_description = "account_type:" + account_type + ", " + accounts_name + ", " + description;
        const log_data = {
            logid,
            history_type: "voucher update",
            servicetablename: "accountingfinancedb",
            tablename: "vouchers",
            filedname: "voucherid",
            filedid: filedid,
            log_description,
            log_status: false,
            verify_status: false,
            verify_note,
            //change info            
            dataupdates,
            description: description,
            account_type: account_type,
        };
        const result = await Save_log_history(log_data);
        if (result.success) {
            //  navigate(-1);
            Toastshow("Saved successfully.");

        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };

    const handle_save_manage_account = async () => {
        if (!voucherid || !String(voucherid).trim()) {
            Toastshow("Please enter voucherid.");
            return;
        }

        if (!manageaccountguid || !manageaccountguid.trim()) {
            Toastshow("Please enter accountguid.");
            return;
        }

        if (!managename || !managename.trim()) {
            Toastshow("Please enter description.");
            return;
        }
        if (manageamount == 0) {
            Toastshow("Please enter amount.");
            return;
        }
        setlogid(Randomcode(15));
        const data = {
            voucherid,
            managename,
            accountsmanagerid: manageaccountguid + "_" + voucherid,
            accountguid: manageaccountguid,
            voucher: voucher,
            ledger_type: "charges",
            account_type: "charges",
            amount: isNaN(Number(manageamount)) ? 0 : Number(manageamount),
            mathedcalc,
            manageacalc,
            status: false

        };
        const result = await Ledger_accounts_manager(data);
        if (result.success) {

            Toastshow("Voucher saved successfully.");
            const dataupdates = {
                log_id: logid,
                status: true,
                mathedcalc,
                managename,
                manageacalc,
                amount: isNaN(Number(manageamount)) ? 0 : Number(manageamount),
            };
            const description = "amt:" + manageamount + ", " + managename + ",Calc:" + manageacalc + ", mathed:" + mathedcalc;
            create_charges_log(dataupdates, manageaccountguid + "_" + voucherid, "charges", voucher, description, "charges update", manageaccountguid);
        } else {
            alert(result.error || "Failed to save voucher.");
        }
    }

    const create_charges_log = async (dataupdates, filedid, account_type, accounts_name, description, verify_note, accountguid) => {

        const log_description = "account_type:" + account_type + ", " + accounts_name + ", " + description;
        const log_data = {
            logid,
            history_type: "Charges",
            servicetablename: "accountingfinancedb",
            tablename: "ledger_accounts_manager",
            filedname: "accountsmanagerid",
            filedid: filedid,
            log_description,
            log_status: false,
            verify_status: false,
            verify_note,
            //change info            
            dataupdates,
            description: description,
            account_type: account_type,
            accountguid
        };
        const result = await Save_log_history(log_data);
        if (result.success) {
            //  navigate(-1);
            Toastshow("Saved successfully.");

        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };
    const handle_save_stock_qty_manage = async () => {
        if (!voucherid || !voucherid.trim()) {
            Toastshow("Please enter voucherid.");
            return;
        }

        if (!stockname || !stockname.trim()) {
            Toastshow("Please enter stockname.");
            return;
        }
        if (!itemname || !itemname.trim()) {
            Toastshow("Please enter itemname.");
            return;
        }
        if (!itemprice || !itemprice.trim()) {
            Toastshow("Please enter itemprice");
            return;
        }
        if (!stockdescription || !stockdescription.trim()) {
            Toastshow("Please enter file description");
            return;
        }
        const fileid = Randomcode(28);
        setlogid(Randomcode(15));
        const data = {
            voucherid,
            fileid,
            price: isNaN(Number(itemprice)) ? 0 : Number(itemprice),
            perday,
            title: stockname,
            itemname,
            description: stockdescription,
            status: false,
            file_type: "stock",
        };
        const result = await Voucher_File_manager(data);
        if (result.success) {

            const dataupdates = {
                log_id: logid,
                status: true,
                filenumber,
                issue_date,
                expiry_date,
                description: stockdescription,
            };

            create_stock_log(dataupdates, fileid, "stock", voucher, stockdescription, "stock");

        } else {
            alert(result.error || "Failed to save voucher.");
        }
    }
    const create_stock_log = async (dataupdates, filedid, account_type, accounts_name, description, verify_note) => {

        const log_description = "account_type:" + account_type + ", " + accounts_name + ", " + description;
        const log_data = {
            logid,
            history_type: "stock",
            servicetablename: "accountingfinancedb",
            tablename: "voucher_file_manager",
            filedname: "fileid",
            filedid: filedid,
            log_description,
            log_status: false,
            verify_status: false,
            verify_note,
            //change info            
            dataupdates,
            description: description,
            account_type: account_type,

        };
        const result = await Save_log_history(log_data);
        if (result.success) {
            Toastshow("Saved successfully.");
            setstockname("");
            setitemname("");
            setitemprice("");
            setstockdescription("");

        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };
    const fetch_voucher_stock_qty = async () => {
        if (!voucherid) return;
        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;
        setIsLoading2(true);
        // Correct path: companies/{company_uid}/vouchers
        const Query = query(
            collection(db, servicetablename, select_company_uid, "voucher_file_manager"),
            where("file_type", "==", "stock"),
            where("voucherid", "==", voucherid)
        );
        const unsubscribe = onSnapshot(
            Query,
            (snapshot) => {
                const vouchers = snapshot.docs.map((docSnap) => ({
                    id: docSnap.id,
                    ...docSnap.data(),
                }));

                setVoucher_file_stock_qty_data(vouchers);
                setIsLoading2(false);
            },
            (error) => {
                console.error("Error fetching vouchers:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    };
    //fils  handle_save_file_manage
    const handle_save_file_manage = async () => {
        if (!voucherid || !voucherid.trim()) {
            Toastshow("Please enter voucherid.");
            return;
        }

        if (!filename || !filename.trim()) {
            Toastshow("Please enter filename.");
            return;
        }
        if (!filedescription || !filedescription.trim()) {
            Toastshow("Please enter file description");
            return;
        }
        const fileid = Randomcode(28);
        setlogid(Randomcode(15));
        const data = {
            voucherid,
            fileid,
            filenumber,
            fileshortname,
            title: filename,
            issue_date,
            expiry_date,
            description: filedescription,
            status: false,
            file_type: "uploadfile",
        };
        const result = await Voucher_File_manager(data);
        if (result.success) {
            const dataupdates = {
                log_id: logid,
                status: true,
                filenumber,
                issue_date,
                expiry_date,
                description: filedescription,
            };

            create_uploadfile_log(dataupdates, fileid, "uploadfile", voucher, filedescription, "uploadfile");
            Toastshow("Saved successfully.");

        } else {
            alert(result.error || "Failed to save voucher.");
        }
    }
    const create_uploadfile_log = async (dataupdates, filedid, account_type, accounts_name, description, verify_note) => {

        const log_description = "account_type:" + account_type + ", " + accounts_name + ", " + description;
        const log_data = {
            logid,
            history_type: "uploadfile",
            servicetablename: "accountingfinancedb",
            tablename: "voucher_file_manager",
            filedname: "fileid",
            filedid: filedid,
            log_description,
            log_status: false,
            verify_status: false,
            verify_note,
            //change info            
            dataupdates,
            description: description,
            account_type: account_type,

        };
        const result = await Save_log_history(log_data);
        if (result.success) {
            //  navigate(-1);
            Toastshow("Saved successfully.");

        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };
    const fetchvouchers = async () => {
        if (!voucherid) return; // avoid query before UID exists 
        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;
        setIsLoading2(true);
        // Correct path: companies/{company_uid}/vouchers
        const productQuery = query(
            collection(db, servicetablename, select_company_uid, "vouchers"),
            where("voucherid", "==", voucherid),
            //   where("status", "==", true)
            //  orderBy("indexnumber", "asc")
        );
        const unsubscribe = onSnapshot(
            productQuery,
            (snapshot) => {
                const vouchers = snapshot.docs.map((docSnap) => ({
                    id: docSnap.id,
                    ...docSnap.data(),
                }));
                const v = vouchers[0] || {};
                setPaypublic(v.paypublic);
                setStatusdata(v.status);
                setVoucher_type(v.voucher_type);
                setVouchersdata(vouchers);
                setEditable(v.editable || false);
                setAmount(v.amount || 0);
                setOld_file_uid(v.logo_uid || "null");
                setLogoUrl(v.logo_url || logo_default);
                setVoucher(v.voucher || "");
                setdescription(v.description || "");
                setIsLoading2(false);
            },
            (error) => {
                console.error("Error fetching vouchers:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    };
    const fetch_voucher_file_manager = async () => {
        if (!voucherid) return;
        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;
        setIsLoading2(true);
        // Correct path: companies/{company_uid}/vouchers
        const Query = query(
            collection(db, servicetablename, select_company_uid, "voucher_file_manager"),
            where("file_type", "==", "uploadfile"),
            where("voucherid", "==", voucherid)
        );
        const unsubscribe = onSnapshot(
            Query,
            (snapshot) => {
                const vouchers = snapshot.docs.map((docSnap) => ({
                    id: docSnap.id,
                    ...docSnap.data(),
                }));

                setVoucher_file_manager_data(vouchers);
                setIsLoading2(false);
            },
            (error) => {
                console.error("Error fetching vouchers:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    };
    //
    const fetch_manage_ledger_accounts = async () => {
        if (!voucherid) return; // avoid query before UID exists
        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;
        setIsLoading2(true);
        // Correct path: companies/{company_uid}/vouchers
        const productQuery = query(
            collection(db, servicetablename, select_company_uid,
                "ledger_accounts"),
            where("account_type", "!=", "master"),

        );

        const unsubscribe = onSnapshot(
            productQuery,
            (snapshot) => {
                const vouchers = snapshot.docs.map((docSnap) => ({
                    id: docSnap.id,
                    ...docSnap.data(),
                }));

                const v = vouchers[0] || {};

                setLedger_accountsdata(vouchers);
            },
            (error) => {
                console.error("Error fetching vouchers:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    };

    const fetchledger_accounts = async () => {
        if (!voucherid) return;
        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;
        setIsLoading2(true);
        const managerQ = query(
            collection(db, servicetablename, select_company_uid, "ledger_accounts_manager"),
            where("voucherid", "==", voucherid),
            orderBy("indexnumber", "asc")
        );
        const unsubscribe = onSnapshot(
            managerQ,
            async (managerSnap) => {
                try {
                    if (managerSnap.empty) {
                        setManage_ledger_accountsdata([]);
                        setIsLoading2(false);
                        return;
                    }

                    // MULTIPLE managers
                    const managerList = managerSnap.docs.map((d) => ({
                        id: d.id,
                        ...d.data(),
                    }));

                    // Get all account numbers
                    const accountguids = managerList
                        .map((m) => m.accountguid)
                        .filter((x) => x);

                    if (accountguids.length === 0) {
                        setManage_ledger_accountsdata([]);
                        setIsLoading2(false);
                        return;
                    }

                    // Fetch all ledger_accounts using IN query
                    const accountsQuery = query(
                        collection(db, servicetablename, select_company_uid, "ledger_accounts"),
                        where("accountguid", "in", accountguids)
                    );

                    const accountsSnap = await getDocs(accountsQuery);

                    if (accountsSnap.empty) {
                        setManage_ledger_accountsdata([]);
                        setIsLoading2(false);
                        return;
                    }

                    const ledgerList = accountsSnap.docs.map((d) => ({
                        id: d.id,
                        ...d.data(),
                    }));

                    // Merge manager and ledger fields
                    const finalData = ledgerList.map((ledger) => {
                        const manager = managerList.find(
                            (m) => m.accountguid === ledger.accountguid
                        );

                        return {
                            ...ledger,
                            ledger_type: manager?.ledger_type || "",
                            manageacalc: manager?.manageacalc || "",
                            mathedcalc: manager?.mathedcalc || "",
                            managerstatus: manager?.status || "",
                            manager_indexnumber: manager?.indexnumber || "",
                            amount: manager?.amount || 0,
                            accountsmanagerid: manager?.accountsmanagerid || 0,
                        };
                    });
                    // FIX: sort by indexnumber (asc)
                    finalData.sort((a, b) => (a.manager_indexnumber || 0) - (b.manager_indexnumber || 0));
                    setManage_ledger_accountsdata(finalData);
                    setIsLoading2(false);
                } catch (err) {
                    console.error("Error:", err);
                    setIsLoading2(false);
                }
            },
            (error) => {
                console.error("Error fetching ledger data:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    };


    useEffect(() => {
        fetch_voucher_stock_qty();
        fetch_voucher_file_manager();
        fetch_manage_ledger_accounts();
        fetchvouchers();
        fetchledger_accounts();
    }, [voucherid]); // IMPORTANT

    //change logo
    const [logo_file, setLogo_file] = useState(null);
    const logo_Upload = async () => {
        if (!logo_file) return;
        if (!old_file_uid) return;
        if (!Cookies.get("guid")) return Toastshow("Please login");
        if (!Cookies.get("select_company_uid")) return Toastshow("Please select company");

        // ⚡ Pass the uid of the company you’re editing
        const result = await Uploader_files({
            file: logo_file,
            servicetablename,
            fileuid: voucherid,
            tablename: "vouchers",
            filename: "logo",
            old_file_uid,
        });

        if (result.success) {
            Toastshow("Successfully!");
            setLogo_file(null);
            fetchvouchers();
        } else {

            setLogo_file(null);
            Toastshow(`Error: ${result.error}`);
        }
    };
    useEffect(() => {
        if (logo_file) {
            logo_Upload();
        }
    }, [logo_file]);
    return (
        <div >
            <div className="b-bottom">
                <table>
                    <tr>
                        <td ><div
                            onClick={() => navigate(-1)}
                            className="button-ui0 text-h2 bold p-2 cursor"
                        >
                            <MdArrowBackIos className="icon" />Edit
                        </div></td>
                        <td width={30}>
                            <div
                                onClick={() => navigate("/?page=vouchers_master")}
                                className="button-ui0 p-2 cursor"
                            >
                                <MdClose className="icon" />
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div className="post-container p-2">

                <div className="post_updates">
                    <div className=" items-back">
                        <div className="b-1 p-1 rounded">
                            <table >
                                <tr>
                                    <td className='text-h3 text-off' width={60}>Voucherid</td>
                                    <td  > <div
                                        className="text-h3 bold"
                                    >
                                        {vouchersdata[0]?.voucherid}
                                    </div></td>

                                </tr>
                                <tr>
                                    <td className='text-h3 text-off'>Create</td>
                                    <td className='text-h3 bold'>
                                        {vouchersdata[0]?.date_time.toDate().toLocaleDateString() ? (
                                            <>
                                                {vouchersdata[0]?.date_time.toDate().toLocaleDateString()}{" "}
                                                {vouchersdata[0]?.date_time.toDate().toLocaleTimeString()}
                                            </>
                                        ) : (
                                            <div className='contact-details'>No date</div>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='text-h3 text-off'>Update</td>
                                    <td className='text-h3'>
                                        {vouchersdata[0]?.date_time_update.toDate().toLocaleDateString() ? (
                                            <>
                                                {vouchersdata[0]?.date_time_update.toDate().toLocaleDateString()}{" "}
                                                {vouchersdata[0]?.date_time.toDate().toLocaleTimeString()}
                                            </>
                                        ) : (
                                            <div className='contact-details'>No date</div>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='text-h3 text-off'>Queue</td>
                                    <td className='text-h3'> {vouchersdata[0]?.queuecode || "N/A"}</td>
                                </tr>
                            </table>
                        </div>
                        <table>
                            <tr>

                                <td>

                                    <div className="logo-div">
                                        {isLoading_banner === true ? (
                                            <Lodinging />
                                        ) : (
                                            <>
                                                <img src={logoUrl || logo_default}
                                                    alt="logo" className="brand-thumbnail" />
                                                <div className="change_image flex center">
                                                    {logo_file !== null ? (
                                                        <Lodingingimg />
                                                    ) : (
                                                        <label>
                                                            <MdAddAPhoto className="icon white cursor" />
                                                            <input
                                                                type="file" accept=".jpg,.jpeg,.png"
                                                                style={{ display: "none" }}
                                                                onChange={async (e) => {
                                                                    const selectedFile = e.target.files[0];
                                                                    if (selectedFile) {
                                                                        setLogo_file(selectedFile);
                                                                        setLogoUrl(URL.createObjectURL(selectedFile));

                                                                    }
                                                                }}
                                                            />
                                                        </label>

                                                    )}

                                                </div>
                                            </>
                                        )}

                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table>
                                        <tr>
                                            <td>
                                                <div className="button-ui3 bold" style={{ color: vouchersdata[0]?.status === true ? "green" : "red" }}>

                                                    #{vouchersdata[0]?.indexnumber} {vouchersdata[0]?.status === true ? "Activate" : "Deactivate"}
                                                </div>
                                            </td>
                                            <td width={130} className='text-h3'>
                                                {vouchersdata[0]?.date_time_update?.toDate ? (
                                                    <>
                                                        {vouchersdata[0]?.date_time_update.toDate().toLocaleDateString()}{" "}
                                                        {vouchersdata[0]?.date_time_update.toDate().toLocaleTimeString()}
                                                    </>
                                                ) : (
                                                    <div className='contact-details'>No date</div>
                                                )}
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>

                            <tr>
                                <td><div className="text-h2 bold">Edit name</div></td>
                            </tr>
                            <tr>
                                <td><input type="text" className="text-h2 bold" value={voucher}
                                    onChange={(e) => setVoucher(e.target.value)}
                                    maxLength={30} placeholder="Enter name" /></td>
                            </tr>
                            <tr>
                                <td>

                                    <div className="text-h2 ">Amount </div></td>
                            </tr>
                            <tr>
                                <td>
                                    <table>
                                        <tr>
                                            <td width={20}><span className="text-h1">₹</span></td>
                                            <td>
                                                <input
                                                    type="text"
                                                    maxLength={10}
                                                    readOnly={!editable}
                                                    className="bold text-h1"
                                                    placeholder="Enter amount"
                                                    value={amount}
                                                    onChange={(e) => {
                                                        let v = e.target.value;

                                                        // allow only digits and dot
                                                        v = v.replace(/[^0-9.]/g, "");
                                                        // prevent more than one dot
                                                        const parts = v.split(".");
                                                        if (parts.length > 2) {
                                                            v = parts[0] + "." + parts.slice(1).join("");
                                                        }

                                                        e.target.value = v;
                                                        setAmount(v);
                                                    }}
                                                />
                                            </td>
                                            <td width={90}>

                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        value={editable}
                                                        checked={editable}
                                                        onChange={(e) => setEditable(e.target.checked)}
                                                    />
                                                    <a className="text-h2">Editable</a>
                                                </label>
                                            </td>
                                        </tr>
                                    </table>

                                </td>
                            </tr>
                            <tr>
                                <td><div className="text-h2 bold">Description</div></td>
                            </tr>
                            <tr>
                                <td><textarea rows={4} value={description} onChange={(e) => setdescription(e.target.value)} maxLength={200} placeholder="Enter description" /></td>
                            </tr>
                            {/* <tr>
                                <td>
                                    <div className="">
                                        <table className="table-fixed">
                                            <tr>
                                                <td>
                                                    <div
                                                        onClick={() => setVoucher_type("receipt")}
                                                        className={`fill p-2 cursor ${voucher_type === "receipt" ? "button-ui green-back" : "button-ui2"}`}
                                                    >
                                                        <MdDownload className="icon" />
                                                        Receipt
                                                    </div>
                                                </td>

                                                <td>
                                                    <div
                                                        onClick={() => setVoucher_type("payment")}
                                                        className={`fill p-2 cursor ${voucher_type === "payment" ? "button-ui red-back" : "button-ui2"}`}
                                                    >
                                                        <MdUpload className="icon" />
                                                        Payment
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </td>
                            </tr> */}
                            {/* <tr>
                                <td>

                                    <label>
                                        <input
                                            type="checkbox"

                                            checked={paypublic}
                                            onChange={(e) => setPaypublic(e.target.checked)}
                                        />
                                        <a className="text-h3">Mark voucher Pay Public or Unmark Staff Only</a>
                                    </label>

                                </td>
                            </tr> */}
                            <tr>
                                <td width={90}>

                                    <label>
                                        <input
                                            type="checkbox"

                                            checked={statusdata}
                                            onChange={(e) => setStatusdata(e.target.checked)}
                                        />
                                        <a className="text-h3">Change status to <b className="bold" style={{ color: statusdata === true ? "green" : "red" }}> {statusdata === true ? "Activate" : "Deactivate"}</b> and Save</a>

                                    </label>
                                </td>
                            </tr>

                        </table>

                        <div className="button-ui p-22 fill text-h1 cursor" onClick={() => handleCreate()}>Save</div>


                    </div>
                </div>
                <div className="post_div">
                    <div className="rounded b-1 ">
                        <div className="b-bottom p-1 items-back-fill" >
                            <table>
                                <tr>
                                    <td> <div className="button-ui0 text-h2 bold fcap">
                                        <PiBooks className="icon" /> Ledger Settings
                                    </div></td>
                                    <td width={30}>

                                    </td>
                                </tr>
                            </table>
                        </div>


                        <div className="ui-grid p-1">
                            <div className="ui-items items-back b-1 rounded p-11">
                                <div className="text-h2">Create a function to handle tax, charges, and other payments.
                                    Use this function to record these amounts in the appropriate accounts for this voucher.</div>
                                <br />
                                <table>
                                    <tr>
                                        <td width={20}><a>A/c</a></td>
                                        <select
                                            className="bold"
                                            onChange={(e) => setManageaccountguid(e.target.value)}
                                        >
                                            <option value="0">Select Ledger Account</option>

                                            {ledger_accountsdata?.map((item, index) => (
                                                <option key={index} value={item.accountguid}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select>

                                    </tr>
                                    {manageaccountguid !== "0" && (
                                        <>
                                            <tr>
                                                <td width={20}><a>Select</a></td>
                                                <td>
                                                    <Ledger_accounts_profile accountguid={manageaccountguid} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width={20}><a className="text-h1">₹</a></td>
                                                <td>


                                                    <table>
                                                        <tr>

                                                            <td >
                                                                <input
                                                                    type="text"
                                                                    maxLength={10}
                                                                    className="bold text-h1"
                                                                    placeholder="Enter amount"
                                                                    value={manageamount}
                                                                    onChange={(e) => {
                                                                        let v = e.target.value;

                                                                        // allow only digits and dot
                                                                        v = v.replace(/[^0-9.]/g, "");
                                                                        // prevent more than one dot
                                                                        const parts = v.split(".");
                                                                        if (parts.length > 2) {
                                                                            v = parts[0] + "." + parts.slice(1).join("");
                                                                        }

                                                                        //  e.target.value = v;
                                                                        setManageamount(v);
                                                                    }}
                                                                />
                                                            </td>
                                                            <td width={30}>

                                                                <div className="button-ui2 text-h1 bold p-0">{mathedcalc}</div>
                                                            </td>
                                                            <td width={30}>
                                                                <div className="button-ui2 text-h1 bold p-0">{manageacalc}</div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <td width={20}><a>Calc</a></td>
                                                </td>
                                                <table>
                                                    <tr>
                                                        <td>
                                                            <select onChange={(e) => setManagecalc(e.target.value)} className="text-h2">
                                                                <option value="+">(+) AddOn Amount</option>
                                                                <option value="-">(-) Discount Amount</option>
                                                            </select>

                                                        </td>
                                                        <td>
                                                            <select onChange={(e) => setmathedcalc(e.target.value)} className="text-h2">
                                                                <option value="%">(%) Percentage</option>
                                                                <option value="=">(=) Equal</option>

                                                            </select>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </tr>
                                            <tr>
                                                <td width={20}><a  >Name</a></td>
                                                <input value={managename} maxLength={30} onChange={(e) => setManagename(e.target.value)} placeholder="Enter Name">
                                                </input>
                                            </tr>
                                            <tr>
                                                <td width={20}><a className="text-h2">Tag</a></td>
                                                <td>
                                                    <select onChange={(e) => {
                                                        setManagenameoption(e.target.value);
                                                        setManagename(e.target.value);

                                                    }} className="text-h2">
                                                        <option  >AddOn Amount</option>
                                                        <option >Discount Amount</option>
                                                        <option >AddOn Amount</option>
                                                        <option >Discount Amount</option>
                                                        <option >AddOn GST Tax</option>
                                                        <option >Discount GST Tax</option>

                                                        <option >AddOn Service Charge</option>
                                                        <option >AddOn Round Off</option>
                                                        <option >AddOn Delivery Charge</option>
                                                        <option >AddOn Packing Charge</option>
                                                        <option >AddOn Convenience Fee</option>
                                                        <option >AddOn Fuel Surcharge</option>

                                                        <option >AddOn Handling Charge</option>
                                                        <option >AddOn Labour Charge</option>
                                                        <option >AddOn Transport Charge</option>
                                                        <option >AddOn Loading/Unloading Charge</option>
                                                        <option >AddOn Insurance Charge</option>
                                                        <option >AddOn Commission</option>
                                                        <option >AddOn Bank Charge</option>
                                                        <option >AddOn Late Fee</option>
                                                        <option >AddOn Penalty Charge</option>
                                                        <option >AddOn Miscellaneous Charge</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr><td></td>
                                                <td> <div className="button-ui2 p-22 fill text-h1 cursor" onClick={() => handle_save_manage_account()}>Save Ledger</div></td>
                                            </tr>
                                        </>
                                    )}


                                </table>

                            </div>
                            {manage_ledger_accountsdata.map((row) => (
                                <div key={row.id} className="ui-items items-back b-1 rounded p-11">
                                    <table >
                                        <tbody >
                                            <tr>
                                                <table>
                                                    <tr> <td>
                                                        <Ledger_accounts_reports_profile accountguid={row.accountguid} />
                                                        {/* <div className="text-h2 bold fcap">
                                                                        {row.name || "No account found"}
                                                                    </div> */}
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                        <td width={130} className='text-h3'>
                                                            Create: {row.date_time?.toDate ? (
                                                                <>
                                                                    {row.date_time.toDate().toLocaleDateString()}{" "}
                                                                    {row.date_time.toDate().toLocaleTimeString()}
                                                                </>
                                                            ) : (
                                                                <div className='contact-details'>No date</div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                </table>


                                                <td width={100} >
                                                    <table>
                                                        <tr>
                                                            <td  >
                                                                <div className="text-h2 fcap">
                                                                    {row.ledger_type || "N/A"}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td >
                                                                <div className="text-h2 bold">
                                                                    {row.manageacalc || ""}{row.amount || ""} {row.mathedcalc || ""}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td >
                                                                <div className="text-h2 bold">
                                                                    {row.managerstatus ? (
                                                                        <div className="green bold text-h2">Activate</div>
                                                                    ) : (
                                                                        <div className="red bold text-h2">Deactivate</div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width={30}>
                                                    {row.account_type === "master" ? (< >Master</>) : (<MdDelete onClick={() => navigate("/?page=delete_master&table=ledger_accounts_manager&filed=accountsmanagerid&history_type=delete&filedid=" + row.accountsmanagerid + "&description=Ledger Settings: " + row.name)} className="icon red cursor" />)

                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <div className="button-ui2 cursor"><IoSwapVertical className="icon" /> {row.manager_indexnumber || ""}</div>
                                                </td>

                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            ))}

                        </div>

                    </div>
                    {/* Stock & Quantity Settings */}
                    <div className="m-top b-1 rounded">
                        <div className="b-bottom p-1 items-back-fill " >
                            <table>
                                <tr>
                                    <td> <div className="button-ui0 text-h2 bold fcap">
                                        <MdOutlineInventory className="icon" /> Stock Inventory Settings
                                    </div></td>
                                    <td width={30}>

                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div className="ui-grid p-1">
                            <div className="ui-items items-back b-1 rounded p-11">
                                <div className="text-h2">Manage the required stock and item quantities for this voucher.</div>
                                <table>
                                    <tr>
                                        <td width={20}><a className="text-off text-h3">Stock name</a></td>
                                        <td>
                                            <input type="text" maxLength={50} value={stockname} onChange={(e) => setstockname(e.target.value)} placeholder="Enter document name" />
                                        </td>
                                    </tr>
                                    {stockname.length > 1 && (
                                        <>
                                            <tr>
                                                <td width={20}><a className="text-off text-h3">Item size</a></td>
                                                <td>
                                                    <input type="text" maxLength={50} value={itemname} onChange={(e) => setitemname(e.target.value)} placeholder="Enter item name" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width={20}><a className="text-off text-h3" >Price</a></td>
                                                <td>
                                                    <input type="text" maxLength={10} value={itemprice} onChange={(e) => {
                                                        let v = e.target.value.replace(/[^0-9.]/g, "");
                                                        const parts = v.split(".");
                                                        if (parts.length > 2) v = parts[0] + "." + parts.slice(1).join("");
                                                        setitemprice(v);
                                                    }} placeholder="Enter price" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width={20}><a  >Description</a></td>
                                                <textarea value={stockdescription} rows={3} onChange={(e) => setstockdescription(e.target.value)} placeholder="Enter  description">
                                                </textarea>
                                            </tr>

                                            <tr>
                                                <td width={20}><a  >Per day</a></td>
                                                <td  >

                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            checked={perday}
                                                            onChange={(e) => setPerday(e.target.checked)}
                                                        />
                                                        <a className="text-h3">Mark as: Charges per day are automatically calculated</a>

                                                    </label>
                                                </td>
                                            </tr>

                                            <tr><td></td>
                                                <td> <div className="button-ui2 p-22 fill text-h1 cursor" onClick={() => handle_save_stock_qty_manage()}>Save</div></td>
                                            </tr>
                                        </>)
                                    }
                                </table>
                            </div>

                            {voucher_file_stock_qty_data.map((row) => (
                                <div key={row.id} className="ui-items items-back b-1 rounded p-11">
                                    <table >
                                        <tbody >
                                            <tr>
                                                <table>
                                                    <tr> <td>
                                                        <div className="text-h2 bold fcap">
                                                            {row.title || "No account found"}
                                                        </div>
                                                    </td>
                                                    </tr>
                                                    <tr> <td>
                                                        <div className="text-h2 fcap">
                                                            {row.itemname || "No account found"}
                                                        </div>
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                        <td width={130} className='text-h3 text-off'>
                                                            Create: {row.date_time?.toDate ? (
                                                                <>
                                                                    {row.date_time.toDate().toLocaleDateString()}{" "}
                                                                    {row.date_time.toDate().toLocaleTimeString()}
                                                                </>
                                                            ) : (
                                                                <div className='contact-details'>No date</div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                </table>


                                                <td width={150} >
                                                    <table>
                                                        <tr>
                                                            <td className="text-off">Price</td>
                                                            <td className="text-h2 bold p-1">{row.price | "0"}</td>
                                                            <td  >
                                                                <div className="text-h2 fcap bold">
                                                                    {row.perday === true ? "Perday" : "One time"}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td >
                                                                <div className="text-h2 bold">
                                                                    {row.status ? (
                                                                        <div className="green bold text-h2">Activate</div>
                                                                    ) : (
                                                                        <div className="red bold text-h2">Deactivate</div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td className="text-off"></td>
                                                            <td width={30}>
                                                                <MdDelete onClick={() => navigate("/?page=delete_master&table=voucher_file_manager&filed=fileid&filedid=" + row.fileid + "&history_type=delete&description=File Settings: " + row.fileshortname)} className="icon red cursor" />


                                                            </td>
                                                        </tr>

                                                    </table>

                                                </td>

                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className="text-h3 text-off fcap">
                                        {row.description || ""}
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                    {/* Manage the required document upload settings for this voucher */}
                    <div className="m-top b-1 rounded">
                        <div className="p-1 b-bottom items-back-fill" >
                            <table>
                                <tr>
                                    <td> <div className="button-ui0 text-h2 bold fcap">
                                        <MdUploadFile className="icon" /> File Settings
                                    </div></td>
                                    <td width={30}>

                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div className="ui-grid p-1">
                            <div className="ui-items items-back b-1 rounded p-11">
                                <div className="text-h2">Manage the required document upload settings for this voucher</div>
                                <table>
                                    <tr>
                                        <td width={20}><a  >Document</a></td>
                                        <td>
                                            <input type="text" maxLength={200} value={filename} onChange={(e) => setFilename(e.target.value)} placeholder="Enter document name" />
                                        </td>
                                    </tr>
                                    {filename.length > 1 && (
                                        <>



                                            <tr>
                                                <td width={20}><a  >Short Name</a></td>
                                                <td>
                                                    <input type="text" maxLength={200} value={fileshortname} onChange={(e) => setFileshortname(e.target.value)} placeholder="Enter file short name" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width={20}><a  >Description</a></td>
                                                <textarea value={filedescription} rows={3} onChange={(e) => setFiledescription(e.target.value)} placeholder="Enter Name">
                                                </textarea>
                                            </tr>

                                            <tr>
                                                <td width={20}><a  >Number</a></td>
                                                <td  >

                                                    <label>
                                                        <input
                                                            type="checkbox"

                                                            checked={filenumber}
                                                            onChange={(e) => setFilenumber(e.target.checked)}
                                                        />
                                                        <a className="text-h3">Mark as: Require Document Number</a>

                                                    </label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width={20}><a  >Issue date</a></td>
                                                <td  >

                                                    <label>
                                                        <input
                                                            type="checkbox"

                                                            checked={issue_date}
                                                            onChange={(e) => setIssue_date(e.target.checked)}
                                                        />
                                                        <a className="text-h3">Mark as: Require Document Issue Date</a>

                                                    </label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width={20}><a  >Expiry date</a></td>
                                                <td  >

                                                    <label>
                                                        <input
                                                            type="checkbox"

                                                            checked={expiry_date}
                                                            onChange={(e) => setExpiry_date(e.target.checked)}
                                                        />
                                                        <a className="text-h3">Mark as: Require Document Expiry Date</a>

                                                    </label>
                                                </td>
                                            </tr>
                                            <tr><td></td>
                                                <td> <div className="button-ui2 p-22 fill text-h1 cursor" onClick={() => handle_save_file_manage()}>Save</div></td>
                                            </tr>
                                        </>)
                                    }
                                </table>
                            </div>

                            {voucher_file_manager_data.map((row) => (
                                <div key={row.id} className="ui-items items-back b-1 rounded p-11">
                                    <table >
                                        <tbody >
                                            <tr>
                                                <table>
                                                    <tr> <td>
                                                        <div className="text-h2 bold fcap">
                                                            {row.title || "No account found"}
                                                        </div>
                                                    </td>
                                                    </tr>
                                                    <tr> <td>
                                                        <div className="text-h2 text-off fcap">
                                                            {row.fileshortname || "No account found"}
                                                        </div>
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                        <td width={130} className='text-h3 text-off'>
                                                            Create: {row.date_time?.toDate ? (
                                                                <>
                                                                    {row.date_time.toDate().toLocaleDateString()}{" "}
                                                                    {row.date_time.toDate().toLocaleTimeString()}
                                                                </>
                                                            ) : (
                                                                <div className='contact-details'>No date</div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                </table>


                                                <td width={150} >
                                                    <table>
                                                        <tr>
                                                            <td className="text-off">Number </td>
                                                            <td  >
                                                                <div className="text-h2 fcap bold">
                                                                    {row.filenumber === true ? "Require" : "no"}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-off">Issue Date</td>
                                                            <td  >
                                                                <div className="text-h2 fcap bold">
                                                                    {row.issue_date === true ? "Require" : "no"}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-off">Expiry date</td>
                                                            <td  >
                                                                <div className="text-h2 fcap bold">
                                                                    {row.expiry_date === true ? "Require" : "no"}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td >
                                                                <div className="text-h2 bold">
                                                                    {row.status ? (
                                                                        <div className="green bold text-h2">Activate</div>
                                                                    ) : (
                                                                        <div className="red bold text-h2">Deactivate</div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </table>

                                                </td>
                                                <td width={30}>
                                                    {row.account_type === "master" ? (<>Master</>) : (<MdDelete onClick={() => navigate("/?page=delete_master&table=voucher_file_manager&filed=fileid&filedid=" + row.fileid + "&history_type=delete&description=File Settings: " + row.fileshortname)} className="icon red cursor" />)

                                                    }
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className="text-h3 text-off fcap">
                                        {row.description || "No account found"}
                                    </div>
                                </div>
                            ))}


                        </div>

                    </div>
                </div>
            </div>
        </div>


    );
}
